import React from 'react';
import { Box, Button, HStack, Text } from '@chakra-ui/react';
import { TPagination } from '@/types';
import SvgIcon from '@/components/atoms/SvgIcon';
import svgIcons from '@/assets/svg/icons';

interface ITablePaginationProps {
  pagination: TPagination;
  isFetchingNextPage?: boolean;
  totalItemsLabel?: string;
}

const CompactTablePagination = ({
  pagination,
  isFetchingNextPage,
  totalItemsLabel = 'Total Items:',
}: ITablePaginationProps) => {
  const totalPages = pagination.totalPages;

  return (
    <HStack style={{ justifyContent: 'space-between', marginTop: '20px' }} width={'100%'}>
      <Text marginLeft={'20px'} fontWeight={'bold'}>
        {totalItemsLabel} {pagination.totalItems}
      </Text>

      <HStack gap={'10px'} width={'30%'}>
        <Text fontWeight={'bold'} minWidth={'90px'}>
          Page: {pagination.currentPage} / {totalPages}
        </Text>

        <Button
          isDisabled={pagination.currentPage === 1}
          onClick={() => pagination.getFirstPage()}
          _hover={{
            backgroundColor: pagination.currentPage === 1 ? '' : 'primary.gray',
          }}
        >
          {'first'}
        </Button>
        <Button
          isDisabled={pagination.currentPage === 1}
          onClick={() => pagination.getPreviousPage()}
          _hover={{
            backgroundColor: pagination.currentPage === 1 ? '' : 'primary.gray',
          }}
        >
          {/* right arrow, flipped horizontally */}
          <Box transform={'scale(-1,1)'}>
            <SvgIcon iconPath={svgIcons.rightArrow} color={'primary.black'} size="14" />
          </Box>
        </Button>
        <Button
          isDisabled={pagination.currentPage === totalPages}
          onClick={() => pagination.getNextPage()}
          _hover={{
            backgroundColor: pagination.currentPage === totalPages ? '' : 'primary.gray',
          }}
          isLoading={isFetchingNextPage}
        >
          <SvgIcon iconPath={svgIcons.rightArrow} color={'primary.black'} size="14" />
        </Button>
        <Button
          isDisabled={pagination.currentPage === totalPages}
          onClick={() => pagination.getLastPage()}
          _hover={{
            color: pagination.currentPage === totalPages ? '' : 'primary.gray',
          }}
        >
          {'last'}
        </Button>
      </HStack>
    </HStack>
  );
};

export default CompactTablePagination;
